module.exports = __webpack_public_path__ + "static/jasper-5430b8f333e470c16b338fc66ea63777.jpg";